export { default as InputPassword } from './input-password';
